/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { DeleteApiJingleCollectionsIdJinglesMutationResponse, DeleteApiJingleCollectionsIdJinglesPathParams, DeleteApiJingleCollectionsIdJinglesQueryParams, DeleteApiJingleCollectionsIdJingles400, DeleteApiJingleCollectionsIdJingles401, DeleteApiJingleCollectionsIdJingles403, DeleteApiJingleCollectionsIdJingles404, DeleteApiJingleCollectionsIdJingles500 } from "../../types/DeleteApiJingleCollectionsIdJingles.ts";
import { deleteApiJingleCollectionsIdJinglesMutationResponseSchema } from "../../zod/JingleCollectionSchemas/deleteApiJingleCollectionsIdJinglesSchema.ts";

function getDeleteApiJingleCollectionsIdJinglesUrl({ id }: { id: DeleteApiJingleCollectionsIdJinglesPathParams["Id"] }) {
  const res = { method: 'DELETE', url: `/api/jingle-collections/${id}/jingles` as const }  
  return res
}

/**
 * @summary Удаление джинглов из подборки
 * {@link /api/jingle-collections/:Id/jingles}
 */
export async function deleteApiJingleCollectionsIdJingles({ id, params }: { id: DeleteApiJingleCollectionsIdJinglesPathParams["Id"]; params: DeleteApiJingleCollectionsIdJinglesQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DeleteApiJingleCollectionsIdJinglesMutationResponse, ResponseErrorConfig<DeleteApiJingleCollectionsIdJingles400 | DeleteApiJingleCollectionsIdJingles401 | DeleteApiJingleCollectionsIdJingles403 | DeleteApiJingleCollectionsIdJingles404 | DeleteApiJingleCollectionsIdJingles500>, unknown>({ method : "DELETE", url : getDeleteApiJingleCollectionsIdJinglesUrl({ id }).url.toString(), params, ... requestConfig })  
  return deleteApiJingleCollectionsIdJinglesMutationResponseSchema.parse(res.data)
}